import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.css'],
})
export class PriceComponent implements OnInit, OnDestroy {
  public vendorsUrl = environment.vendorsUrl;
  public whatsappUrl =
    'https://wa.me/18494043557?text=Hola!%20me%20interesa%20conocer%20m%C3%A1s%20sobre%20la%20plataforma%20de%20Tix.do%20%20para%20publicar%20mi%20evento.%20Gracias!';

  public mobileMenuOpen = false;

  public navItems = [
    { label: 'Eventos', routerLink: '/events/all' },
    { label: 'Precios', routerLink: '/precios' },
    { label: 'Publicar evento', href: `${environment.vendorsUrl}/register` },
    { label: 'Contacto', routerLink: '/contacto' },
  ];

  constructor(private renderer: Renderer2, private router: Router) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'pricing-page');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'pricing-page');
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }

  navigate(item: { label: string; routerLink?: string; href?: string }): void {
    this.closeMobileMenu();
    if (item.routerLink) {
      this.router.navigate([item.routerLink]);
    } else if (item.href) {
      window.location.href = item.href;
    }
  }

  goHome(): void {
    this.closeMobileMenu();
    this.router.navigate(['/']);
  }
}